import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { applyPhoneMask, getPhoneState } from './../../js/autorization/phone.utils'

export function usePhoneMask(modelRef, options = {}) {
  const inputEl = ref(null)
  const mask = ref(null)

  const state = computed(() => getPhoneState(modelRef.value || '', mask.value))

  const setMaskedValue = (val) => {
    const v = val ?? ''
    if (mask.value) {
      mask.value.value = v
      modelRef.value = mask.value.value 
    } else {
      modelRef.value = v
    }
  }

  const init = (el) => {
    if (!el || mask.value) return

    mask.value = applyPhoneMask(el, options)

    setMaskedValue(modelRef.value)

    mask.value.on('accept', () => {
      modelRef.value = mask.value.value
    })
  }

  const destroy = () => {
    if (!mask.value) return
    mask.value.destroy()
    mask.value = null
  }

  watch(
    inputEl,
    (el) => {
      if (el) init(el)
      else destroy()
    },
    { immediate: true }
  )

  watch(
    () => modelRef.value,
    (v) => {
      if (!mask.value) return
      if (mask.value.value !== (v ?? '')) mask.value.value = v ?? ''
    }
  )

  onBeforeUnmount(destroy)

  return { inputEl, state, setMaskedValue, mask }
}